import CryptoJS from "./crypto-js";

//登录加密
export function loginEncrypt (params) {
  const SECRET_KEY = CryptoJS.enc.Utf8.parse("eaA8eBa7EfeMfcfZ");//秘钥
  const SECRET_IV = CryptoJS.enc.Utf8.parse("TRYTOCN394402133");//偏移量
  if (typeof (params) == "object") {
    params = JSON.stringify(params);//需要转成字符串
  }

  let data = CryptoJS.enc.Utf8.parse(params);
  const encrypted = CryptoJS.AES.encrypt(data, SECRET_KEY, {
    iv: SECRET_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString();

  return encrypted
}

//注册加密
export function registerEncrypt (params) {
  const SECRET_KEY = CryptoJS.enc.Utf8.parse("1DB8eBb7FfeMfdfA");//秘钥
  const SECRET_IV = CryptoJS.enc.Utf8.parse("TGYTRCN394552143");//偏移量
  if (typeof (params) == "object") {
    params = JSON.stringify(params);//需要转成字符串
  }

  let data = CryptoJS.enc.Utf8.parse(params);
  const encrypted = CryptoJS.AES.encrypt(data, SECRET_KEY, {
    iv: SECRET_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString();

  return encrypted
}

//解密
export function decrypt (params) {
  const SECRET_KEY = CryptoJS.enc.Utf8.parse("eaA8eBa7EfeMfcfZ");
  const SECRET_IV = CryptoJS.enc.Utf8.parse("TRYTOCN394402133");
  const encryptedHexStr = CryptoJS.enc.Hex.parse(params);
  const str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  const decrypt = CryptoJS.AES.decrypt(str, SECRET_KEY, {
    iv: SECRET_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}
